angular
  .module('bb.listing_search')
  .factory('AppointmentSearchService', AppointmentSearchService);

AppointmentSearchService.$inject = ['$resource'];
function AppointmentSearchService($resource) {
  const Appointments = $resource('/appointment/:type/');

  const TeamAppointments = $resource('/appointment/team/v2/');

  const AppointmentPermissions = $resource(
    '/appointments/:appointmentId/permissions',
    { appointmentId: '@appointmentId' },
  );

  function searchAppointments(searchParams, hasNewListingsSearchAPI) {
    if (searchParams.searchType === 'team' && hasNewListingsSearchAPI) {
      return TeamAppointments.get(searchParams).$promise;
    }

    return Appointments.get(searchParams).$promise;
  }

  function getPermission(appointmentId) {
    return AppointmentPermissions.get({ appointmentId }).$promise;
  }

  const AppointmentPermissionsMany = $resource(
    '/appointments/permissions_many',
  );

  function getPermissionsMany(appointmentIds) {
    return AppointmentPermissionsMany.get({ appointmentIds }).$promise;
  }

  return {
    getPermissionsMany,
    searchAppointments,
    getPermission,
  };
}

export {};
